<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Manage Chat Notification Settings</h3>
    </div>
  </div>
  <form class="form" [formGroup]="notificationSoundForm" autocomplete="off">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="form-section form-section-first">
        <div class="form-group">
          <table style="margin: auto">
            <tr>
              <td>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  style="
                    border-radius: 0;
                    text-align: left;
                    bottom: 0;
                    background-color: white;
                    width: 100%;
                  "
                  (click)="firstSound.click()"
                >
                  <i class="flaticon-add-circular-button fa-s"></i>New Chat Notification Sound
                  <input
                    style="display: none"
                    #firstSound
                    type="file"
                    name="firstSound"
                    (change)="firstSoundChanged($event)"
                  />
                </button>
              </td>
              <td>
                <audio
                  style="height: 36px; margin: 10px"
                  controls
                  [src]="firstSoundSrc | safe : 'url'"
                ></audio>
              </td>
            </tr>
            <tr>
              <td>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  style="border-radius: 0; text-align: center; bottom: 0; background-color: white"
                  (click)="secondSound.click()"
                >
                  <i class="flaticon-add-circular-button fa-s"></i>Chat Notification Remainder Sound
                  <input
                    style="display: none"
                    #secondSound
                    type="file"
                    name="firstSound"
                    (change)="secondSoundChanged($event)"
                  />
                </button>
              </td>
              <td>
                <audio
                  style="height: 36px; margin: 10px"
                  controls
                  [src]="secondSoundSrc | safe : 'url'"
                ></audio>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field appearance="outline" class="mat-form-field-fluid">
                  <mat-label>Repetitions Loop Number</mat-label>
                  <input matInput type="number" formControlName="repetitions" min="1" />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="mat-form-field-fluid">
                  <mat-label>Snooze Seconds</mat-label>
                  <input matInput type="number" formControlName="seconds" min="20" />
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td style="padding-left: 15px; padding-top: 15px">
                <div class="mat-form-field-fluid mb-4">
                  <mat-label class="row">{{
                    notificationSoundForm.controls.mute.value ? 'Active' : 'Mute'
                  }}</mat-label>
                  <mat-slide-toggle class="row mt-2 mr-2" formControlName="mute"></mat-slide-toggle>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </form>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          class="mr-2"
          mat-raised-button
          matTooltip="Cancel changes"
          (click)="dialogRef.close()"
        >
          Cancel</button
        >&nbsp;
        <button
          type="submit"
          class="mr-2"
          mat-raised-button
          color="primary"
          (click)="save()"
          matTooltip="Save"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
